import React, { useRef, useCallback, useState } from 'react';
import './EditableBox.scss';
import ContentEditable from 'react-contenteditable';
import sanitizeHtml from 'sanitize-html';
import { useEffect } from 'react';

const EditableBox = ({
    onSave,
    value,
    sectionId,
    isActive,
    onFocus,
    disabled,
}) => {
    /** This variable is used because onKeyDown listens for 'Enter' key. However, 'Enter' key also triggers an onBlur since it
     * removes focus from an input. This boolean handles logic to prevent double section saving when pressing 'Enter'
     */
    const [enterPressed, setEnterPressed] = useState(false);

    const text = useRef(value);

    const input = React.createRef();

    const onContentChange = useCallback((val) => {
        const sanitizeConf = {
            allowedTags: ['b', 'i', 'a', 'p'],
            allowedAttributes: { a: ['href'] },
        };

        text.current = sanitizeHtml(val, sanitizeConf);
    }, []);

    useEffect(() => {
        isActive && input.current.focus();
    }, []);

    const onBlur = useCallback(() => {
        if (!enterPressed) onSave(sectionId, text.current);
        setEnterPressed(false);
    }, [sectionId, text]);

    const onEnter = useCallback(
        (event) => {
            if (event.key === 'Enter') onSave(sectionId, text.current);
            setEnterPressed(true);
        },
        [sectionId, text]
    );

    return (
        <div
            className={`cg-editable-box ${
                isActive ? 'cg-editable-box__active' : ''
            }  ${disabled ? 'cg-editable-box__disabled' : ''}`}
        >
            <span> · </span>

            <ContentEditable
                innerRef={input}
                html={text.current}
                onChange={(e) => onContentChange(e.currentTarget.innerHTML)}
                onFocus={onFocus}
                onBlur={onBlur}
                className="cg-editable-box__input"
                disabled={disabled}
                onKeyDown={onEnter}
            />
        </div>
    );
};

export default EditableBox;
